export const RETRIEVING_MEMBERS = 'Retrieving members';
export const RETRIEVING_APPROVALS = 'Retrieving approvals';
export const UPDATING_POST_STATUS = 'Updating post status';
export const UPDATING_COMMENT_STATUS = 'Updating comment status';
export const UPDATING_ALL_POSTS = 'Updating all posts';
export const UPDATING_ALL_COMMENTS = 'Updating all comments';
export const EVALUATING_SUPPORT_CONVERSATION = 'Evaluating support conversation';
